var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusyPayrollIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-997.85-106.34H-162.2a3.69,3.69,0,0,1,3.69,3.69V267.25a0,0,0,0,1,0,0h-843a0,0,0,0,1,0,0V-102.65A3.69,3.69,0,0,1-997.85-106.34Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-717.06,266.35S-524,227.87-442.39,143.71C-386.55,86.1-329.84,3-221.41-5.38S28.05,72.34,50.16,156.93c28.91,110.62,9.29,169.53,9.29,169.53Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.79,22.77c-4.6-1.19-6.07-2.43-6.07-4.35,0-2.21,2-3.74,5.46-3.74,3.61,0,4.94,1.72,5.06,4.25h4.48a8.08,8.08,0,0,0-6.5-7.72V6.78H22.15v4.37c-3.93.85-7.09,3.4-7.09,7.31,0,4.68,3.87,7,9.51,8.36,5.07,1.22,6.08,3,6.08,4.88,0,1.4-1,3.62-5.47,3.62-4.17,0-5.81-1.86-6-4.25H14.7c.24,4.44,3.56,6.93,7.45,7.76v4.39h6.07V38.87c4-.75,7.08-3,7.08-7.19C35.3,25.93,30.39,24,25.79,22.77Z",
    style: {
      fill: "#636c75"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusyPayrollIcon);
export default __webpack_public_path__ + "static/media/busy_payroll_icon.4d55baaefd51dddf340ced3da17782fa.svg";
export { ForwardRef as ReactComponent };